export default __webpack_public_path__ + "b8922172822a58be29cbfceda8a122fc.svg";